export const introSeleccionEstandar = [
    {
      title: "¿Cómo elegir el estándar adecuado y adaptar tu contrato para varias blockchains?",
      value: `
  Ahora que conoces los principales estándares de tokens y las diferencias entre las redes blockchain, llega el momento clave de cualquier proyecto de tokenización o dApp:  
  **elegir el estándar adecuado y preparar tu contrato inteligente para ser lanzado en una o varias blockchains**.
  
  En la siguiente sección aprenderás:
  
  - A identificar cuándo te conviene un estándar ERC20 (fungible), ERC721 (NFT), ERC1155 (multi-activo), BEP20, TRC20 u otros.
  - Qué factores considerar según el objetivo de tu proyecto (inversión, coleccionable, gobernanza, utilidades, gaming, etc.).
  - Cómo adaptar tu contrato y código fuente para que funcione correctamente en redes compatibles como Ethereum, Polygon, BNB Chain (BSC), TRON y más.
  - Buenas prácticas para que tus tokens sean reconocidos y transferibles entre diferentes plataformas y wallets.
  - Recomendaciones para ahorrar tiempo y reducir errores al migrar o clonar tu proyecto entre blockchains.
  
  
  `
    }
  ];
  
  export default introSeleccionEstandar;
  